import TaxonomyAdminScreen from "../taxonomy/taxonomy-admin-screen.tsx";

export default function CountriesScreen() {
  return <TaxonomyAdminScreen type="countries" title="کشورها" />;
}
